import axiosService from '../../services/axios.service';
import { getEndpointBase } from '../../services/api.service';
import { EmailTemplate } from '../../types/emailTemplate.types';

const userService = {
  getSelf() {
    return axiosService.get(getEndpointBase(`user`));
  },

  getEmailTemplates() {
    return axiosService.get(getEndpointBase(`user/mail`));
  },

  updateEmailTemplate(template: EmailTemplate) {
    return axiosService.put(getEndpointBase(`user/mail`), template);
  },
};

export default userService;
